<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import CodeApiServices from "@/services/api/code.api";
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'


export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: "fas fa-clipboard-list-check",
      title: "Evaluaciones Coordinadas",
      routes: ["Informes", "Evaluaciones Coordinadas"]
    },
    model: {
        search: {
        collections: {
          academicYears: [],
          centers: [],
          evaluationTypes: [],
        },
        filters: {
          academicYear: null,
          center: null,
          centerDisabled: false,
          evaluationType: null,
          evaluationTypesDisabled: false,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'description',
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        class: 'col-md-4',
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
        onChanged: this.onChangedAcademicYears,
      },
      {
        name: 'center',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'CSEE',
        placeholder: 'Seleccionar',
        validations: "required",
        error: "Favor seleccionar un CSEE.",
        class: 'col-md-4',
        options: this.model.search.collections.centers,
        value: this.model.search.filters.center,
        onChanged: this.onChangedCenter,
        disabled: this.model.search.filters.centerDisabled,
      },
      {
        name: 'evaluationType',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Tipo de Evaluación',
        placeholder: 'Seleccionar',
        class: 'col-md-4',
        options: this.model.search.collections.evaluationTypes,
        value: this.model.search.filters.evaluationType,
        onChanged: this.onChangedEvaluationTypes,
        disabled: this.model.search.filters.evaluationTypesDisabled,
      },
    ]},
  },
  async mounted() {
      this.initFilters();
  },
  methods: {
    async initFilters(){
      await CodeApiServices.GetReportCoordinatedAssessmentsParams().then(({data}) => {
     
      this.model.search.collections.academicYears = data.collections.academicYears;
      this.model.search.collections.centers = data.collections.csee;
      this.model.search.collections.evaluationTypes = data.collections.evaluationTypes;
     });
    },
    async onChangedAcademicYears() {
      
    },
    async onChangedCenter() {
     
    },
    async onChangedEvaluationTypes() {
     
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (isValid) {
        this.process();
      }
    },
    async process() {
      await ReportServices.getReport('coordinatedAssessments', {
        academicYearId: this.model.search.filters.academicYear.id,
        centerId: this.model.search.filters.center?.id,
        evaluationTypeId: this.model.search.filters.evaluationType?.id,
      })
      .then(res => DocumentServices.Download(res.data));
    },
  },
}
</script>